import { addNotification, notificationStates } from '@components/Notification';
import { paidLeaveOption } from './Leave.constants';

/** Start of local calendar day (for comparisons with react-datepicker values). */
const startOfLocalDay = (d) => {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
};

/**
 * Used with react-datepicker `filterDate` so past calendar days are not selectable.
 * Today and future dates return true.
 */
export const isLeaveDateSelectableInCalendar = (date) => {
  const picked = startOfLocalDay(date);
  const today = startOfLocalDay(new Date());
  return picked >= today;
};

/** Blocks past dates (e.g. manual input). Returns false if the pick should be ignored. */
export const canUseLeaveDateSelection = (date) => {
  if (date == null) return true;
  if (isLeaveDateSelectableInCalendar(date)) return true;
  addNotification({
    message: 'Cannot select past dates! Please choose current or future date.',
    level: notificationStates.error,
  });
  return false;
};

export const validateLeaveForm = (formData) => {
  const { year, month, day } = formData?.leaveDate || {};
  const yi = Number(year);
  const mi = Number(month);
  const di = Number(day);
  if (
    !Number.isFinite(yi) ||
    !Number.isFinite(mi) ||
    !Number.isFinite(di) ||
    di === 0 ||
    mi === 0 ||
    yi === 0
  ) {
    addNotification({
      message: `Invalid Date Please enter valid date !`,
      level: notificationStates.error,
    });
    return false;
  }

  // Check if selected date is in the past (today allowed)
  const selectedDate = startOfLocalDay(new Date(yi, mi - 1, di));
  const today = startOfLocalDay(new Date());

  if (selectedDate < today) {
    addNotification({
      message:
        'Cannot select past dates! Please choose current or future date.',
      level: notificationStates.error,
    });
    return false;
  }

  if (yi < 2023) {
    addNotification({
      message: 'Please choose date after 2023 !',
      level: notificationStates.error,
    });
    return false;
  }
  if (!formData.leaveType?.value) {
    addNotification({
      message: `Please Choose Leave Type`,
      level: notificationStates.error,
    });
    return false;
  }
  if (formData.leaveType?.value === paidLeaveOption.value) {
    if (!formData.paidLeaveType?.value) {
      addNotification({
        message: `Please Choose Paid Leave Type`,
        level: notificationStates.error,
      });
      return false;
    }
  }
  if (!formData.leaveManager?.value) {
    addNotification({
      message: `Please Choose Leave Manager`,
      level: notificationStates.error,
    });
    return false;
  }
  return true;
};

export const getSelectedTableData = (leaveData, selectedManager) => {
  return [
    {
      label: 'Leave Type',
      value: leaveData.type,
    },
    {
      label: 'Comment',
      value: leaveData.comment,
    },
    {
      label: 'Manager',
      value: selectedManager.label,
    },
    {
      label: 'Leave Date',
      value: leaveData.leaveDate,
    },
  ];
};
